<app-layout-one-column>
  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
    <div><h2>You do not have permission to view this page..</h2></div>
    <div>
        <hr>
        <h3>Believe this is an error?</h3>

        <p>Contact the Unified Service Center at 800-621-8335, 
          Monday-Friday, 8:30 AM-4:45 PM CT.
        </p>
    </div>
  </div>
</app-layout-one-column>


